// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:01
import { PasswordArgs_abstract } from './../../abstract/SagaBase/Defines/PasswordArgs_abstract';
export class PasswordArgs extends PasswordArgs_abstract {}
